import type { ParkingHistory } from '@parkingbase/ecommerce-api-dev';

/**
 * Whether the garage behind a parking-history row offers the View Pass affordance.
 *
 * ## Invariants:
 * - Absence means ENABLED. Why: every garage predates this flag, so reading a missing value as off
 *   would withdraw the pass from the entire estate the moment this shipped. The API applies the
 *   same default on its side (`DBGarage.getViewPassEnabled`); both ends must agree or the button
 *   and the setting disagree for any garage nobody has touched.
 * - Judged PER ROW, never per page. Why: Parking History, the header's active-session chip and the
 *   landing page can each list sessions at different garages, so one page-level answer would apply
 *   one garage's setting to another garage's ticket.
 * - A missing ROW is not the same as a missing VALUE: it means there is no session, so there is
 *   nothing to open and the answer is false. Defaulting to true there would render a control that
 *   opens an empty modal.
 */
export function isViewPassEnabledForRow(item: ParkingHistory | null | undefined): boolean {
  if (!item) return false;

  return item.viewPassEnabled ?? true;
}
